/* const API_URL = "http://localhost:5005/api"; */
const API_URL = "https://librarize.it/api";

export { API_URL };
